import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { TeamService } from 'src/app/shared/services/team.service';
import { Team } from 'src/app/shared/models/team/team';

@Component({
  selector: 'app-higher-logic-integration',
  templateUrl: './higher-logic-integration.component.html',
  styleUrls: ['./higher-logic-integration.component.scss'],
})
export class HigherLogicIntegrationComponent implements OnInit, OnDestroy {
  selectedCommunity;
  communities;
  create: boolean = false;
  private teamSubscription;
  team: Team;

  constructor(
    private dialogRef: MatDialogRef<HigherLogicIntegrationComponent>,
    private teamService: TeamService
  ) {}
  ngOnInit(): void {
    this.teamSubscription = this.teamService.team.subscribe((team) => {
      this.team = team;
      this.teamService.getTeamsUsingExistingCommunities(this.team.id).subscribe((teams) => {
        if (teams && teams.length > 0) {
          this.communities = teams;
          this.selectedCommunity = this.communities[0];
        }
      });
    });
  }

  createCommunity() {
    if (this.create) {
      this.teamService.createNewCommunity(this.team.id).subscribe((res) => {
        if (res) {
          this.dialogRef.close();
        }
      });
    } else {
      this.teamService
        .linkHLTeamToNewCommunity(this.team.id, this.selectedCommunity.id)
        .subscribe((res) => {
          if (res) {
            this.dialogRef.close();
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.teamSubscription?.unsubscribe();
  }
}
